import React from "react";

const currencies = [
  "EUR",
  "GBP",
  "AUD",
  "NZD",
  "USD",
  "KWD",
  "JOD",
  "CHF",
  "CAD",
  "SGD",
  "ILS",
  "QAR",
  "AED",
  "SAR",
  "PLN",
  "MYR",
  "BRL",
  "RON",
  "TRY",
  "CNY",
  "CNH",
  "HKD",
  "NOK",
  "SEK",
  "ZAR",
  "EGP",
  "MXN",
  "CZK",
  "TWD",
  "THB",
  "UYU",
  "PHP",
  "ARS",
  "RUB",
  "INR",
  "JPY",
  "ISK",
  "PKR",
  "HUF",
  "NGN",
  "KRW",
  "IDR",
  "DKK",
  "VND",
  "CLP",
  "GBX",
  "ILA",
  "ZAC",
] as const;

type currencyTypes = typeof currencies[number];

export const LandingCurrencyContext =
  React.createContext<
    ReturnType<typeof useLandingCurrencySelector> | undefined
  >(undefined);

export const useLandingCurrencySelector = () => {
  const [currency, setCurrency] = React.useState<currencyTypes>("USD");

  return { currency, setCurrency, currencies };
};

export const LandingCurrencyContextProvider = ({
  children,
}: React.PropsWithChildren<any>) => {
  const { ...stuff } = useLandingCurrencySelector();
  return (
    <LandingCurrencyContext.Provider value={{ ...stuff }}>
      {children}
    </LandingCurrencyContext.Provider>
  );
};

export const useLandingCurrencyContext = () => {
  const context = React.useContext(LandingCurrencyContext);
  if (typeof context === "undefined") {
    throw new Error(
      "LandingCurrencyContext  can only be accessed from within it's provider"
    );
  }
  return context;
};
